// extracted by css-extract-rspack-plugin
export default {"root":"NotificationsPage_root__1CKm6","header":"NotificationsPage_header__n1ZUm","calendarWrapper":"NotificationsPage_calendarWrapper__l3PlU"};